<template>
    <div>
        <div class="col-sm-12">
            <div class="ibox">
                <div class="ibox-title" style="border: none;">
                    <el-form id="elForm" :inline="true" :model="formInline" ref="formInline" label-width="120px" label-position="right" class="demo-form-inline" size="medium">
                      <el-form-item label="市：" prop="cityID" v-show="show.selCity">
                        <el-select v-model="formInline.cityID" placeholder="请选择市" @change="selectChange(1,formInline.cityID)">
                            <el-option v-for="item in selectcity" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="区县：" prop="countryID" v-show="show.selCountry">
                        <el-select v-model="formInline.countryID" placeholder="请选择区">
                            <el-option v-for="item in selectarea" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="机构名称：">
                            <el-input v-model="formInline.orgName" placeholder="请输入机构名称"></el-input>
                      </el-form-item>
                      <el-form-item label="评测月份：">
                            <el-date-picker v-model="formInline.scoreMonth" :editable='false' value-format='yyyy-MM' type="month" placeholder="选择日期" :picker-options="pickerOptions" @change='getScorePolicy'></el-date-picker>
                      </el-form-item>
                      <el-form-item label="督导标准名称：" prop="scorePolicyAreaId">
                         <el-select v-model="formInline.scorePolicyAreaId" placeholder="请选择督导标准名称">
                            <el-option v-for="item in scorePolicyList" :key="item.scorePolicyAreaId" :label="item.scorePolicyName" :value="item.scorePolicyAreaId"></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item>
                          <el-button class="btn-primary" @click="getScoreList(formInline)">查询</el-button>
                          <!--<el-button class="btn-primary" @click="getScoreList(formInline)">查询</el-button>
                          <el-button class="btn-default" @click="onReset('formInline')">重置</el-button>-->
                      </el-form-item>
                    </el-form>
                    <div style="padding: 10px 0;border-top: 1px solid #ddd;">
                        <!-- <button class="white_but but" @click="opederive($event)">导出</button> -->
                         <el-button v-for='(item,index) in generalArea' :key='index'  @click="doClick(item.operFunc,undefined,undefined,$event)">{{item.operName}}</el-button>
                        <div style="float: right;position: relative;margin-top: 5px;">
                          <button :class="settingClass" @click="setting()"></button>
                          <ul class="setting_ul" v-show="setShow">
                            <template v-if='thData.length>0'>
                              <template v-for='list in thData'>
                                <li v-if='list.hideable==true'>
                                  <i v-if='list.show==true' class='checked' @click="choShow($event)">✔</i>
                                  <i v-else class='checked' @click="choShow($event)"></i>
                                  <span>{{list.label}}</span>
                                </li>
                                <li v-else>
                                  <i v-if='list.show==true' class="jin">✔</i>
                                  <span>{{list.label}}</span>
                                </li>
                              </template>
                            </template>
                            <template v-else>
                              <li style="text-align: center;">暂无数据</li>
                            </template>
                          </ul>
                        </div>
                    </div>
                    <!--<div style="padding: 20px 0;border-top: 1px solid #ddd;">注意：每月测评一次，次月第一天，出上月的测评结果</div>-->
                    <template v-if='thData.length>0'>
                      <el-table ref="multipleTable" id="tableList" height="620" class="table-bordered" :data="tableData" @sort-change="sortChange" :loading="tableLoading" element-loading-text="拼命加载中" bordertooltip-effect="dark" style="width: 100%">
                        <template v-for='list in thData'>
                          <template v-if="list.show==true">
                            <el-table-column :fixed="true" :prop="list.prop" :label="list.label" v-if='list.label==="机构名称"' min-width="200" :show-overflow-tooltip='true'></el-table-column>
                            <el-table-column :prop="list.prop" :label="list.label" v-else-if='list.label==="督导标准名称"' min-width="200" :show-overflow-tooltip='true'></el-table-column>
                            <el-table-column :prop="list.prop" :label="list.label" v-else-if='list.label==="评测日期"' :render-header="renderHeaderDate" min-width="100"></el-table-column>
                            <el-table-column :prop="list.prop" :label="list.label" v-else-if='list.label==="评测月份"' :render-header="renderHeaderM" min-width="100"></el-table-column>
                            <el-table-column :prop="list.prop" :label="list.label" v-else-if='list.label==="评测总分"' sortable='custom' :render-header="renderHeaderTotal" min-width="120">
                              <template slot-scope="scope">
                                <div :class="'hbg'+scope.row[list.template]">{{scope.row[list.prop]}}</div>
                              </template>
                            </el-table-column>
                            <el-table-column :label="list.label" v-else-if='list.elTableColumns!=undefined'>
                              <template v-for='item in list.elTableColumns'>
                                <el-table-column :prop="item.prop" :label="item.label" v-if='item.label==="大类得分"' sortable='custom' :render-header="renderHeaderScore" min-width="120">
                                  <template slot-scope="scope">
                                    <div :class="'hbg'+scope.row[item.template]">{{scope.row[item.prop]}}</div>
                                  </template>
                                </el-table-column>
                                <el-table-column :prop="item.prop" :label="item.label" v-else-if='item.sortable==true' sortable='custom' :show-overflow-tooltip='true'></el-table-column>
                                <el-table-column :prop="item.prop" :label="item.label" v-else :show-overflow-tooltip='true'></el-table-column>
                              </template>
                            </el-table-column>
                            <el-table-column :prop="list.prop" :label="list.label" v-else :show-overflow-tooltip='true'></el-table-column>
                          </template>
                        </template>
                        <el-table-column label="操作" width="50">
                          <template slot-scope="scope">
                            <!-- <span @click="orgmgrDel(scope.$index,scope.row)" style='cursor: pointer;'>详情</span> -->
                             <span v-for='(item,index) in listArea' :key='index' style='cursor: pointer;' @click="doClick(item.operFunc,scope.$index,scope.row)" >{{item.operName}}</span>
                          </template>
                        </el-table-column>
                      </el-table>
                    </template>
                    <div v-else style="height: 100px;line-height: 100px;text-align: center;border: 1px solid #ebeef5;">暂无数据</div>
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-sizes="[10, 25, 50, 100]" :page-size="formInline.pageSize" layout="total,sizes,prev,pager,next,jumper" :total="total" style="margin-top: 10px;">
                    </el-pagination>
                </div>
            </div>
        </div>
        <!--彈出的添加-->
      <el-dialog id='dialog' :visible.sync="dialogTableVisible" :show-close="false" :fullscreen="true" :showClose="false" width="100%" height="100%" :close-on-click-modal='false'>
        <router-view v-on:close="close" v-if='dialogTableVisible'></router-view>
      </el-dialog>
  </div>
</template>
<script>
import {MessageBox, Loading} from 'element-ui'
import api from '../../com/ajax' // ajax请求封装
import config from '../../com/config' // url配置文件
import common from '../../com/common'
export default {
  name: '',
  data () {
    return {
      dialogTableVisible: false,
      tableData: [], // 数据表数据
      thData: [], // 表头数据
      scorePolicyList: [], // 督导标准名称
      selectcity: [],
      selectarea: [],
      formInline: {// 筛选条件表单数据
        provinceID: '', // 必须
        cityID: '',
        countryID: '',
        orgName: '',   // 机构名称
        scoreMonth: '',   // 评测月份
        scorePolicyAreaId: '', // 督导标准id
        oldScorePolicyAreaId: '', // 老督导标准id
        yearName: '',
        order: '',
        pageNum: 1,
        pageSize: 10,
        sort: ''
      },
      PolicyListParam: {

      },
      content: '',
      categoryItemId: '',
      show: {
        selCountry: false,
        selCity: false
      },
      currentPage: 1,
      total: 0,
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        }
      },
      setShow: false,
      settingClass: 'setting_but',
      loading: false,
      tableLoading: false,
      generalArea:[],
      listArea:[]
    }
  },
  created () {
    var that = this
    var cId = $(window.frameElement).attr('cId')
    if (cId !== undefined) {
      that.categoryItemId = cId
    }
    return new Promise(function (resolve) {
      api.post(config.khsHost + 'spv/policy/hhs/getScoreMonthList.do').then(function (json) {
        that.formInline.scoreMonth = json.body[0]
        resolve(true)
      })
    }).then(function (r) {
      api.post(config.host + 'org/getOrgDetailWithDefault.do').then(function (json) {
        var orgInfo = json.body.orgInfo
        if (orgInfo.scopeType === 1) { // 省级
          that.show.selCity = true
          that.show.selCountry = true
          that.getList(config.host + 'common/getAreasList.do', { 'parentID': orgInfo.provinceID }, 'selectcity', true)
          that.PolicyListParam = {
            scoreMonth: that.formInline.scoreMonth, provinceID: orgInfo.provinceID
          }
          that.getList(config.khsHost + 'spv/policy/hhs/getScorePolicyList.do', that.PolicyListParam, 'scorePolicyList', 'scorePolicy')
        } else if (orgInfo.scopeType === 2) { // 市级
          that.show.selCountry = true
          that.formInline.cityID = orgInfo.cityID
          that.getList(config.host + 'common/getAreasList.do', { 'parentID': orgInfo.cityID }, 'selectarea', true)
          that.PolicyListParam = {
            scoreMonth: that.formInline.scoreMonth,
            provinceID: orgInfo.provinceID,
            cityID: orgInfo.cityID
          }
          that.getList(config.khsHost + 'spv/policy/hhs/getScorePolicyList.do', {scoreMonth: that.formInline.scoreMonth,
            provinceID: orgInfo.provinceID, // 必须
            cityID: orgInfo.cityID}, 'scorePolicyList', 'scorePolicy')
        } else { // 区县级
          that.formInline.cityID = orgInfo.cityID
          that.formInline.countryID = orgInfo.countryID
          that.PolicyListParam = {
            scoreMonth: that.formInline.scoreMonth,
            provinceID: orgInfo.provinceID,
            cityID: orgInfo.cityID,
            countryID: orgInfo.countryID
          }
          that.getList(config.khsHost + 'spv/policy/hhs/getScorePolicyList.do', {scoreMonth: that.formInline.scoreMonth,
            provinceID: orgInfo.provinceID, // 必须
            cityID: orgInfo.cityID,
            countryID: orgInfo.countryID}, 'scorePolicyList', 'scorePolicy')
        }
        that.formInline.provinceID = orgInfo.provinceID
      })
    })
  },
  mounted(){
    let btnList = window.paramFromParent
    btnList = common.getBtnList(btnList)
    this.generalArea = btnList.generalArea
    this.listArea = btnList.listArea
  },
  methods: {
    renderHeaderDate (h, { column, $index }) {
      return (
        <span>
            <span>{column.label}</span>
            <el-tooltip placement="bottom-start">
                <div slot="content" style="width:180px">生成评测结果的时间；按月评测，每月1日出上月评测结果</div>
                <i class="el-icon-question" style="color:#9FCBF8;margin-left: 3px;"></i>
            </el-tooltip>
        </span>
      )
    },
    renderHeaderM (h, { column, $index }) {
      return (
        <span>
            <span>{column.label}</span>
            <el-tooltip effect="dark" content="评测时间范围" placement="bottom-start">
                <i class="el-icon-question" style="color:#9FCBF8;margin-left: 3px;"></i>
            </el-tooltip>
        </span>
      )
    },
    renderHeaderScore (h, { column, $index }) {
      return (
        <span>
            <span>{column.label}</span>
            <el-tooltip effect="dark" placement="bottom-start">
              <div slot="content">蓝色表示“好”<br/>绿色表示“中”<br/>黄色表示“差”<br/>红色表示“零分”</div>
              <i class="el-icon-question" style="color:#9FCBF8;margin-left: 3px;"></i>
            </el-tooltip>
        </span>
      )
    },
    renderHeaderTotal (h, { column, $index }) {
      return (
        <span>
            <span>{column.label}</span>
            <el-tooltip effect="dark" placement="bottom-start">
              <div slot="content">蓝色表示“好”<br/>绿色表示“中”<br/>黄色表示“差”<br/>红色表示“零分”</div>
              <i class="el-icon-question" style="color:#9FCBF8;margin-left: 3px;"></i>
            </el-tooltip>
        </span>
      )
    },
    renderHeader (h, { column, $index }) {
      return (
        <span style="display:inline-block;width: 68%;">
          <el-tooltip effect="dark" content={column.label} placement="bottom-start">
              <span style="white-space: nowrap;line-height: 12px;overflow: hidden;text-overflow: ellipsis;display: inline-block;vertical-align: inherit;width: 100%;">{column.label}</span>
          </el-tooltip>
        </span>
      )
    },
    encodeHtml (str) {
      var reg = /^\<[\w0-9]*\>/i
      var tag = reg.exec(str)

      if (tag == null) {
        return
      }
      tag = tag.toString()

      tag = tag.substr(1, tag.length - 2)
      var inner = str.substr(tag.length + 2, str.length - tag.length * 2)

      let dd = document.createElement(tag)
      dd.innerHTML = inner
      return dd // 返回HTML节点对象
    },
    getScorePolicy (val) {
      this.PolicyListParam.scoreMonth = val
      this.getList(config.khsHost + 'spv/policy/hhs/getScorePolicyList.do', this.PolicyListParam, 'scorePolicyList')


    },
    getList (url, param, key, hasData) {
      var that = this
      that[key + ''] = []
      api.post(url, param).then(function (response) {
        that[key + ''] = response.body.list
        if (hasData && hasData === true) {
          that[key + ''].splice(0, 0, {id: '', name: '全部'})
        } else if (key === 'scorePolicyList') {
          if (that[key + ''].length > 0) {
            that.formInline.scorePolicyAreaId = response.body.list[0].scorePolicyAreaId
            // that.formInline.oldScorePolicyAreaId = response.body.list[0].scorePolicyAreaId
          } else {
            that.formInline.scorePolicyAreaId = ''
            that.formInline.oldScorePolicyAreaId = ''
          }
          if (hasData === 'scorePolicy') {
            that.getScoreList(that.formInline, true)
          }
        }
      })
    },
    close (flag, refresh) {
      this.dialogTableVisible = flag
      if (refresh === true) {
        this.getScoreList(this.formInline)
      }
    },
    orgmgrDel (index, row) { // 详情
      this.dialogTableVisible = true
      $('#dialog .el-dialog__header').css('padding', '0')
      this.$router.push({path: '/scoreDetail/' + row.id})
    },
    showMsgTip (value, type) { // 提示消息
      if (type === 'false') {
        this.$message({
          message: value
        })
      } else {
        this.$message({
          message: value,
          type: type
        })
      }
    },
    handleSizeChange (val) { // 分页每页条数改变事件
      this.formInline.pageSize = val
      this.getData()
    },
    handleCurrentChange (val) { // 分页页数改变事件
      this.formInline.pageNum = val
      this.getData()
    },
    getScoreList (pram, first) { // 获取表格数据
      var that = this
      that.currentPage=that.formInline.pageNum=1
      that.tableLoading = true
      if (that.formInline.oldScorePolicyAreaId === that.formInline.scorePolicyAreaId && first !== true) { // 督导标准没变
        that.getData()
        return false
      } else {
        that.formInline.oldScorePolicyAreaId = that.formInline.scorePolicyAreaId
      }
      // 重载表格
      that.thData = [{
        show: true,
        sortable: false
      }]
      that.formInline.order = ''
      that.formInline.sort = ''
      return new Promise(function (resolve) {
        api.post(config.khsHost + 'spv/policy/hhs/getTableHeader.do', {scorePolicyAreaId: that.formInline.scorePolicyAreaId, categoryId: that.categoryItemId}).then(function (response) {
          that.categoryItemId = ''
          if (response.success === true) {
            that.thData = response.body
            resolve()
          } else {
            that.thData = []
            that.total = []
            that.tableLoading = false
          }
        })
      }).then(function (r) {
        that.getData()
      })
    },
    selectChange (type, parentID) { // 下拉框值改变事件  type=1市下拉框的值改变事件   type=2区下拉框的值改变事件
      this.formInline.countryID = ''
      if (parentID === '') {
        this.selectarea = [{id: '', name: '全部'}]
      } else {
        this.getList(config.host + 'common/getAreasList.do', { 'parentID': parentID }, 'selectarea', true)
      }
    },
    opederive (val) {
      let dom = val.target
      if ($(dom).attr('readonly')) {
        return false
      }
      $(dom).attr('readonly', 'readonly')
      let url = config.khsHost + 'spv/policy/hhs/export.do?'
      let num = 0
      let self = this
      return new Promise(function (resolve) {
        for (var i in self.formInline) {
          num++
          if (self.formInline[i] !== '' && self.formInline[i] !== null && self.formInline[i] !== undefined) {
            url += i + '=' + self.formInline[i] + '&'
          }
          if (num === 11) {
            resolve()
          }
        }
      }).then(function () {
        window.location.href = url + 'Haiziguo-Token=' + localStorage.getItem('Haiziguo-Token')
        setTimeout(function () {
          $(dom).removeAttr('readonly')
        }, 5000)
      })
    },
    setting () { // 设置
      this.setShow = !this.setShow
      if (this.setShow === false) {
        this.settingClass = 'setting_but'
      } else {
        this.settingClass = 'setting_but on'
      }
    },
    sortChange (data) {
      if (data.order === 'ascending') {
        this.formInline.order = 'asc'
        // this.formInline.sort = 'score'
        this.formInline.sort = data.prop
        this.getData()
      } else if (data.order === 'descending') {
        this.formInline.order = 'desc'
        this.formInline.sort = data.prop
        this.getData()
        // this.formInline.sort = 'score'
      }
    },
    doClick(operFunc,index,row,event){
      switch(operFunc){
       case 'doExport':this.opederive(event);break
       case 'showDetail':this.orgmgrDel(index,row);break
      }
    },
    getData () {
      var that = this
      api.post(config.khsHost + 'spv/policy/hhs/getOrgScoreList.do', that.formInline).then(function (response) {
        if (response.success === true) {
          that.tableData = response.body.list
          that.total = response.body.page.total
        } else {
          that.tableData = []
          that.total = []
        }
        setTimeout(function () {
          var tableBoxH = $('#tableList').width()
          var tableH = $('#tableList .el-table__header').width()
          if (tableH > tableBoxH) { // 有滚动条
            var height = $('#tableList').find('.el-table__body-wrapper').height()
            $('#tableList').find('.el-table__fixed').css('max-height', '600px')
            $('#tableList').find('.el-table__fixed-body-wrapper').css('max-height', (height - 17) + 'px')
          } else {
            $('#tableList').find('.el-table__fixed').css('max-height', '')
            $('#tableList').find('.el-table__fixed-body-wrapper').css('max-height', '')
          }
          that.tableLoading = false
        }, 200)
      })
    },
    choShow (val) {
      let dom = val.target
      let self = this
      var index = $('.setting_ul i').index($(dom))
      if ($(dom).html() === '') {
        self.thData[index].show = true
      } else {
        self.thData[index].show = false
      }
      setTimeout(function () {
        self.$refs.multipleTable.doLayout()
        setTimeout(function () {
          var tableBoxH = $('#tableList').width()
          var tableH = $('#tableList .el-table__header').width()
          if (tableH > tableBoxH) { // 有滚动条
            var height = $('#tableList').find('.el-table__body-wrapper').height()
            $('#tableList').find('.el-table__fixed').css('max-height', '600px')
            $('#tableList').find('.el-table__fixed-body-wrapper').css('max-height', (height - 17) + 'px')
          } else {
            $('#tableList').find('.el-table__fixed').css('max-height', '')
            $('#tableList').find('.el-table__fixed-body-wrapper').css('max-height', '')
          }
          self.tableLoading = false
        }, 100)
      }, 100)
    }
  },
  updated: function () {
    var self = this
    $(document).click(function (event) {
      var evt = event.srcElement ? event.srcElement : event.target
      var parent = $('.setting_ul').parent()
      if ($(evt).is(parent)) return // 如果是元素本身，则返回
      else if ($(evt).is(parent.find('.setting_ul'))) return // 如果是元素本身，则返回
      else if ($(evt).is(parent.find('i'))) return // 如果是元素本身，则返回
      else if ($(evt).is(parent.find('li'))) return // 如果是元素本身，则返回
      else if ($(evt).is(parent.find('span'))) return // 如果是元素本身，则返回
      else if ($(evt).is(parent.find('.setting_but'))) return // 如果是元素本身，则返回
      else {
        self.setShow = false
        self.settingClass = 'setting_but'
      }
    })
  }
}
</script>

<style scoped>
.ml15 {
    margin-left: 15px;
}
#tableList .el-table .cell, .el-table th>div{
    padding-left: 0;
    padding-right: 0;
}
.el-table--scrollable-x .el-table__body-wrapper{
    height: 480px !important; 
}
.but {
    height: 35px;
    width: 60px;
    border-radius: 6px;
    margin-left: 10px;
    border: none;
    cursor: pointer;
}
.white_but {
    color: #333;
    background: #fff;
    border: 1px solid #d9d9d9;
}

#tableList .space{
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  vertical-align: inherit;
  width: 100%;
}

.setting_but{
  border: none;
  font-size: 20px;
  height: 26px;
  width:40px;
  background:url('../../assets/img/setting.png')
}

.setting_but:focus{
  border: none;
}

.on{
  background:url('../../assets/img/settingHov.png')
}

.setting_ul{
  border: 1px solid #ddd;
  border-bottom: none;
  width: 140px;
  position: absolute;
  z-index: 100;
  left: -100px;
  top: 26px;
  background: #fff;
  max-height: 211px;
  overflow-y: auto;
}

.setting_ul li{
  height: 30px;
  line-height: 30px;
  padding: 0 10px;
  border-bottom: 1px solid #ddd;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.setting_ul i{
  width: 13px;
  height: 13px;
  background-color: #FFFFFF;
  border: 1px solid #9eaab8;
  display: inline-block;
  color: #ccc;
  line-height: 10px;
  cursor: pointer;
  text-align: center;
  font-size: 14px;
  margin-right: 5px;
}
.setting_ul .jin{
  border-color:#ccc;
}

.setting_ul .checked{
  color:#4c9bfa;
}

.hbg{
    color:#999
}

.hbg3{
    color:#30B0F6
}
.hbg2{
    color:#00C853
}
.hbg1{
    color:#F5A623
}
.hbg0{
    color:#FD6A7C
}
</style>


// WEBPACK FOOTER //
// src/components/supervisor/score.vue